<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { hostUrl , themeColor } from '@/utils/fun'
import { mapMutations } from 'vuex'
export default {
  name: 'App',
  methods: {
      ...mapMutations('home',['setThemeColor']),

    async addWatermark(value) {
      const background = "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' height='100px' width='280px'>" +
        "<text transform='translate(50, 100) rotate(-20)' fill='rgba(0,0,0,0.075)' font-size='18'>" + value + "</text></svg>\")";

      const layer = document.createElement('div');

      layer.className = 'watermark';
      layer.style.position = 'fixed';
      layer.style.top = '64px';
      layer.style.left = '80px';
      layer.style.width = '100%';
      layer.style.height = '100%';
      layer.style.pointerEvents = 'none';
      layer.style.zIndex = '99999';
      layer.style.backgroundImage = background

      document.body.appendChild(layer);

      document.body.style.pointerEvents = 'auto';
    }
  },
  mounted() {
    hostUrl && this.setThemeColor( themeColor(hostUrl) )

    let userInfo = JSON.parse(localStorage.getItem('userInfo'));

    if (!userInfo) {
      console.warn('userInfo not defined');
      return false;
    }

    this.addWatermark(userInfo.username)
  }
}
</script>
